export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
export const RESET_ACTIVE_TAB = 'RESET_ACTIVE_TAB';



// WEBPACK FOOTER //
// ./src/screens/Class/Details/store/types.js